/**
 * Who stands behind Nurture, in one place: the footer, the legal pages, the Trust page and the
 * data-request page all read from here, so a change of officer or address is one edit.
 * Company details match zenquip.com (ZenQuip Healthcare Private Limited).
 */
export const COMPANY = {
  legalName: 'ZenQuip Healthcare Private Limited',
  address: '802, Naman Residency 2, Mansarovar, Jaipur, Rajasthan 302020, India',
  cin: 'U86900RJ2026PTC115318',
  website: 'https://www.zenquip.com',
  supportEmail: 'support@zenquip.com',
} as const;

export const GRIEVANCE_OFFICER = {
  name: 'Kiran K Thakar',
  email: 'grievance@zenquip.com',
  phone: '+91 96540 06424',
  phoneHref: 'tel:+919654006424',
  /** Resolution commitment, as in the privacy policy. */
  resolveDays: 30,
} as const;

/** India crisis lines, as in ZenQuip's site-wide disclaimer. `href` dials on a phone. */
export const HELPLINES = [
  { name: 'Tele-MANAS', number: '14416', href: 'tel:14416', alt: { number: '1-800-891-4416', href: 'tel:18008914416' } },
  { name: 'KIRAN', number: '1800-599-0019', href: 'tel:18005990019' },
  { name: 'Vandrevala Foundation', number: '+91 9999 666 555', href: 'tel:+919999666555' },
] as const;

/** ZenQuip's helplines reference, served from this app so the link never breaks. */
export const HELPLINES_PDF = '/crisis-helplines-india.pdf';
